import HeroSectionComponent from '../components/HeroSectionComponent';
import ValueComponent from '../components/ValueComponent';
import AssociationComponent from '../components/AssociationComponent';
import AboutPage from './AboutPage';

const HomePage = () => (
  <div>
    <HeroSectionComponent />
    <AssociationComponent />
    <AboutPage />
    <ValueComponent />
  </div>
);

export default HomePage;
